import { Companion_instance28p2tgglllsme as Companion_instance } from './RecyclerViewRendererSet.mjs';
import { Companion_instanceyb6grjkdzphm as Companion_instance_0 } from './RecyclerViewData.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function children(_this__u8e3s4, items, id, render) {
  _this__u8e3s4.vde(Companion_instance.ydc(id, render));
  reactive(_this__u8e3s4, ($this$reactive) => {
    _this__u8e3s4.xde(Companion_instance_0.wde($this$reactive.baj(items)));
    return Unit_instance;
  });
}
//region block: exports
export {
  children as children3sl29z5no2wyp,
};
//endregion

//# sourceMappingURL=Recycler2.ext.mjs.map
